import * as React from 'react';
import AuthService from '../../services/authService';
import Translate from '../../common/functions/translate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faFolderOpen, faChevronRight, faSyncAlt, faCog } from '@fortawesome/free-solid-svg-icons';
import UserMenu from '../profile/userMenu';
//import Language from '../language/language';
import * as Constants from '../../common/constants';
import preval from 'preval.macro';
import format from 'date-fns/format';

let authService = new AuthService();

const menuNavigation = (props: any) => {
    const newDate = preval`module.exports = new Date()`;
    const buildDate = format(new Date(newDate), 'yyyyMMdd');

    return <div style={{ minWidth: '280px', padding: '60px 20px' }}>
        {authService.isAuthenticated() ?
            <div>
                <div style={{ textTransform: "none", color: "#555", display: "flex", alignItems: "center", marginRight: "10px" }}>
                    <div className="header-user-name" style={{ marginRight: "7px", fontSize: 14 }}>
                        {authService.getUserName()}
                        <div style={{ fontSize: 12, marginTop: "3px", color: "#777" }}>
                            {Translate(authService.getUserRole()) + " - " + authService.getRegion()}
                        </div>
                    </div>
                </div>
                <ul className="list-items" style={{ margin: '20px 0px 40px 0px' }}>
                    {authService.checkIsTrader() || authService.checkIsRegionalManager() ?
                        <>
                            <li key='newoffer' onClick={() => props.changeRoute('/newoffer')}>
                                <div className="item-icon">
                                    <FontAwesomeIcon icon={faPlus} />
                                </div>
                                <div className="item-info">
                                    <div className="item-name">
                                        {Translate("Creating")} {Translate("new offer")}
                                    </div>
                                </div>
                                <div className="item-actions">
                                    <FontAwesomeIcon icon={faChevronRight} />
                                </div>
                            </li>
                            <li key='listoffers' onClick={() => props.changeRoute('/offers')}>
                                <div className="item-icon">
                                    <FontAwesomeIcon icon={faFolderOpen} />
                                </div>
                                <div className="item-info">
                                    <div className="item-name">
                                        {Translate("Opening")} {Translate("existing offer")}
                                    </div>
                                </div>
                                <div className="item-actions">
                                    <FontAwesomeIcon icon={faChevronRight} />
                                </div>
                            </li>
                            {props.showSynchroBtn ?
                                <li key='synchronize' onClick={() => {
                                    props.synchronize()
                                    props.closeDrawer()
                                }}>
                                    <div className="item-icon">
                                        <FontAwesomeIcon icon={faSyncAlt} />
                                    </div>
                                    <div className="item-info">
                                        <div className="item-name">
                                            {Translate("Synchronization")}
                                        </div>
                                    </div>
                                    <div className="item-actions">
                                        <FontAwesomeIcon icon={faChevronRight} />
                                    </div>
                                </li> : null}
                        </> : null}
                    <li key='settings' onClick={() => { props.changeRoute('/settings') }}>
                        <div className="item-icon">
                            <FontAwesomeIcon icon={faCog} />
                        </div>
                        <div className="item-info">
                            <div className="item-name">
                                {Translate("Settings")}
                            </div>
                        </div>
                        <div className="item-actions">
                            <FontAwesomeIcon icon={faChevronRight} />
                        </div>
                    </li>
                    {/* 
                        // @ts-ignore */}
                    <UserMenu mobileView={true} closeDrawer={props.closeDrawer} />
                </ul>
                <div style={{ width: "200px", textAlign: "center", fontSize: "0.8em", color: "#555" }} >
                    <div>© {new Date().getFullYear()} ICB - InterConsult Bulgaria</div>
                    <div>All rights reserved</div>
                    <div>ver. {Constants.version}.{Constants.buildNumber === "YYYYMMDD" ? buildDate : Constants.buildNumber}</div>
                </div>
            </div>
            : null}
        {/* <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
            <Language></Language>
        </div> */}
    </div>
}

export default menuNavigation;